/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

import { defaultSocialChannelLinks, socialChannelLinks } from './config';

export const getSocialChannelLinks = (marketLanguage: MarketLanguage) => {
    // @ts-ignore - Element implicitly has an any type - Touch and Change
    return socialChannelLinks[marketLanguage] ?? defaultSocialChannelLinks;
};
